import { SerializedMeterModel } from '@enmon/commons/lib/tools';
import { IndexedDatabase } from './indexedDatabase';

export class MeterModelsDB extends IndexedDatabase<SerializedMeterModel> {
  constructor(newData?: SerializedMeterModel[]) {
    super('meter_models', ['id'], newData, { keyPath: 'id' });
  }
}
